<template>
    <div>
        <nav class="navbar navbar-inverse navbar-fixed-top">
            <div class="container-fluid">
                <div class="navbar-header">
                    <a class="navbar-brand" href="#">BitScheduler</a>
                </div>
                <!-- <div id="navbar" class="navbar-collapse collapse">
                    <ul class="nav navbar-nav navbar-right">
                        <li><a href="#">Help</a></li>
                    </ul>
                </div> -->
            </div>
        </nav>
        <div class="container-fluid">
            <div class="row">
                <div id="menu" class="col-sm-3 col-md-2 sidebar">
                    <ul class="nav nav-sidebar">
                        <li><a id="dashboard" class="menu-item" href="#" v-on:click="currentComponent = 'home'"><i class="material-icons">home</i>&nbsp;Home</a></li>
                        <li><a id="setting" class="menu-item" href="#" v-on:click="currentComponent = 'settingMenu'"><i class="material-icons">settings_applications</i>&nbsp;Setting</a></li>
                    </ul>
                </div>
                <div id="main-panel" class="col-sm-6 col-sm-offset-3 col-md-10 col-md-offset-2 main">
                    <!-- <component
                        ref="main-panel"
                        v-bind:is="currentComponent"
                        v-bind:name="this.team ? this.team.name : ''"
                        v-bind:teamKey="this.team ? this.team.teamKey : ''"
                        @save-team-data="saveTeamData"
                        @save-calendar-data="saveCalendarData"
                        @show-team-form="showTeamForm"
                        @show-calendar-form="showCalendarForm"
                    /> -->
                    <home ref="home" v-if="this.currentComponent == 'home'" v-bind:name="this.team ? this.team.name : ''" v-bind:teamKey="this.team ? this.team.teamKey : ''" />
                    <setting-menu ref="settingMenu" v-if="this.currentComponent == 'settingMenu'"
                        @show-team-form="showTeamForm"
                        @show-calendar-form="showCalendarForm"
                    />
                    <team-form ref="teamForm" v-if="this.currentComponent == 'teamForm'" @save-team-data="saveTeamData" />
                    <calendar-form ref="calendarForm" v-if="this.currentComponent == 'calendarForm'"
                        v-bind:orgCalendarId="this.team.calendarId"
                        v-bind:orgApiKey="this.team.apiKey"
                        @save-calendar-data="saveCalendarData"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Team from '../models/Team.js'
import Home from '../components/Home.vue'
import SettingMenu from '../components/SettingMenu.vue'
import TeamForm from '../components/TeamForm.vue'
import CalendarForm from '../components/CalendarForm.vue'

export default {
    components: {
        Home,
        SettingMenu,
        CalendarForm,
        TeamForm,
    },
    data: function() {
        return {
            team: null,
            currentComponent: 'home'
        }
    },
    props: {
        ownerId: String
    },
    created: async function() {
        let team = await Team.findByOwnerId(this.ownerId)
        
        if (team) {
            this.team = team
        }
    },
    methods: {
        showTeamForm: function() {
            console.info('called showTeam')
            this.currentComponent = 'teamForm'
            // この時点では $refs には settingMenu しか存在しないので、初期値のセットは updated() で行う。
        },
        showCalendarForm: function() {
            this.currentComponent = 'calendarForm'
            // この時点では $refs には settingMenu しか存在しないので、初期値のセットは updated() で行う。
        },
        saveTeamData: function(name, teamKey, attendanceLimit) {
            console.info('emit name : ' + name)
            console.info('emit teamKey : ' + teamKey)

            this.team.name = name
            this.team.teamKey = teamKey;
            this.team.attendanceLimit = attendanceLimit;
            this.team.update()
            this.currentComponent = 'settingMenu'
        },
        saveCalendarData: function(calendarId, apiKey) {
            console.info(`emit register calendar: ${calendarId}, apiKey: ${apiKey}`)
            this.team.calendarId = calendarId
            this.team.apiKey = apiKey
            this.team.update()
            this.currentComponent = 'settingMenu'
        }
    },
    updated: function() {
        if (this.currentComponent == 'teamForm') {
            // teamKey は変更不可の場合、第三引数は true
            // 更新モードなので第四引数は true
            this.$refs.teamForm.setDefaultData(this.team.name, this.team.teamKey, true, true, this.team.attendanceLimit)
        }
        else if (this.currentComponent == 'calendarForm') {
            this.$refs.calendarForm.setDefaultData(this.team.calendarId, this.team.apiKey)
        }
    }
}
</script>

<style scoped>
    .nav-sidebar {
        margin-top: 20px;
    }
</style>
